import React, { useState } from 'react';

// Histórico de novidades — sempre adicionar uma entrada NOVA no topo do array ao lançar algo.
// O `id` da entrada mais recente é o que controla o popup automático (WhatsNewBanner);
// mudar o id faz o popup reaparecer pra quem já tinha fechado o anterior.
const BADGE_STYLE = {
  'NOVOS RECURSOS': { bg: '#dcfce7', color: '#15803d' },
  'MELHORIAS':      { bg: '#dbeafe', color: '#1d4ed8' },
  'CORREÇÕES':      { bg: '#fef3c7', color: '#92400e' },
};

export const WHATS_NEW_HISTORY = [
  {
    id: 'wn-2026-09-18-visual',
    date: '18/09/2026',
    version: 'Cara nova: Colorido Vivo + Escuro Premium',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-palette', text: 'O app ganhou um visual novo! O tema padrão agora é o "Colorido Vivo" — um roxo vibrante, mais moderno e amigável.' },
      { icon: 'fa-moon', text: 'E tem o modo "Escuro Premium" (dourado, sofisticado): ative em Configurações → Preferências → Modo escuro, e troque quando quiser.' },
      { icon: 'fa-wand-magic-sparkles', text: 'Também repaginamos o acabamento: botões com um toque mais suave (aquele "quique" estilo iPhone) e cantos mais macios em todo o app.' },
    ],
  },
  {
    id: 'wn-2026-09-16-copiloto-meumes',
    date: '16/09/2026',
    version: 'Copiloto no WhatsApp e "Meu Mês" pra compartilhar',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-comments-dollar', text: 'Agora dá pra PERGUNTAR qualquer coisa pro assistente no WhatsApp/Telegram e ele responde olhando os seus dados reais — tipo "posso gastar 500 esse fim de semana?", "quanto sobrou pra lazer?" ou "como estão minhas dívidas?". Antes ele só entendia alguns comandos prontos.' },
      { icon: 'fa-robot', text: 'É a mesma inteligência do Consultor IA que já existe dentro do app, agora direto no seu WhatsApp — sem abrir nada, é só mandar a pergunta por texto ou áudio.' },
      { icon: 'fa-share-nodes', text: 'Nova tela "Meu Mês" (em Relatórios): monta um resumo lindo do seu mês numa única imagem — saldo, entradas, saídas e onde você mais gastou — pronto pra compartilhar no WhatsApp com um toque.' },
    ],
  },
  {
    id: 'wn-2026-07-23-divida',
    date: '23/07/2026',
    version: 'Abatimento de dívida agora desconta certo',
    badge: 'CORREÇÕES',
    items: [
      { icon: 'fa-hand-holding-dollar', text: 'Ao registrar o pagamento de uma dívida com desconto (abatimento por pagar adiantado), agora sai da conta só o que você realmente pagou — parcela menos o desconto. Antes o app debitava o valor cheio da conta.' },
      { icon: 'fa-eye', text: 'O modal de pagamento passou a mostrar as três linhas separadas: quanto sai da conta, o desconto e quanto abate da dívida — sem confusão.' },
      { icon: 'fa-rotate-left', text: 'Novo botão para desfazer um pagamento de dívida: devolve o dinheiro para a conta e o valor para o saldo devedor. Útil pra corrigir uma baixa lançada errada.' },
    ],
  },
  {
    id: 'wn-2026-07-23-fatura',
    date: '23/07/2026',
    version: 'Compras no cartão vão pra fatura certa',
    badge: 'CORREÇÕES',
    items: [
      { icon: 'fa-credit-card', text: 'Compra no cartão lançada pelo WhatsApp/Telegram agora entra na fatura em que ela realmente cai (vencimento), e não no dia da compra. Era isso que deixava o total da fatura diferente do cartão de verdade.' },
      { icon: 'fa-calendar-day', text: 'A data da compra não se perde mais: o extrato do cartão mostra "Compra 22/07" na linha, e o topo mostra de qual fatura você está vendo.' },
      { icon: 'fa-file-invoice-dollar', text: 'Ao lançar no app, o campo agora é "Data da compra" e logo abaixo aparece em qual fatura ela vai cair — sem adivinhação.' },
      { icon: 'fa-scale-balanced', text: 'A fatura do cartão também sobe sozinha quando o lançamento chega pelo WhatsApp com o app fechado (antes só o extrato subia, e o "Fatura atual" ficava atrasado).' },
      { icon: 'fa-wand-magic-sparkles', text: 'Tem lançamento antigo na fatura errada? Em Configurações → Dados apareceu o botão "Corrigir faturas de cartão": ele mostra a lista e move tudo pro lugar certo.' },
      { icon: 'fa-clock', text: 'Datas que apareciam um dia antes do que deveriam (efeito de fuso horário) agora mostram o dia certo em todo o app.' },
      { icon: 'fa-list-check', text: 'Na tela de Lançamentos, compras de cartão mostram embaixo da data o dia da compra ("compra 22/07") — fica fácil bater linha a linha com o app do banco. O CSV exportado também ganhou as colunas Data da compra e Cartão.' },
      { icon: 'fa-money-bill-wave', text: 'Pagou a fatura antes do vencimento? Agora as compras daquela fatura também recebem a baixa automática (antes só davam baixa se você pagasse no dia do vencimento ou depois).' },
    ],
  },
  {
    id: 'wn-2026-07-21-ia',
    date: '21/07/2026',
    version: 'Correção: leitura de comprovantes no WhatsApp',
    badge: 'CORREÇÕES',
    items: [
      { icon: 'fa-robot', text: 'A leitura de comprovantes e áudios pela IA no WhatsApp/Telegram voltou a funcionar — um parâmetro que o serviço de IA deixou de aceitar estava travando toda a análise em "Analisando seu comprovante...".' },
      { icon: 'fa-comment-dots', text: 'E se por algum motivo a análise falhar, agora o assistente te avisa na hora em vez de ficar mudo — é só reenviar.' },
    ],
  },
  {
    id: 'wn-2026-07-21-qty',
    date: '21/07/2026',
    version: 'Correção: quantidade de cotas com vírgula',
    badge: 'CORREÇÕES',
    items: [
      { icon: 'fa-calculator', text: 'Os campos de quantidade de cotas agora aceitam vírgula normalmente ("3,00462"). Antes, em alguns teclados, a vírgula se perdia e a quantidade ficava gigante — inflando o valor do ativo.' },
      { icon: 'fa-shield-halved', text: 'Proteção dupla: o app pergunta antes de salvar uma quantidade que não bate com o valor investido, e a atualização automática de cotações se recusa a gravar valores implausíveis.' },
    ],
  },
  {
    id: 'wn-2026-07-20-manut',
    date: '20/07/2026',
    version: 'Manutenção de Residência e tempo real',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-screwdriver-wrench', text: 'A aba "Veículos" virou "Manutenções": agora você controla também a manutenção da sua casa/imóvel (pintura, encanamento, ar-condicionado...). Ao cadastrar, escolha se é Veículo ou Residência.' },
      { icon: 'fa-bell', text: 'Os lembretes de próxima manutenção e o lançamento automático da despesa funcionam igual pros dois — veículo e residência.' },
      { icon: 'fa-bolt', text: 'Sincronização em tempo real: lançou pelo WhatsApp com o app aberto? Agora aparece na hora, sem risco de se perder — e vale também entre celular e computador.' },
    ],
  },
  {
    id: 'wn-2026-07-20-fix',
    date: '20/07/2026',
    version: 'Correção: lançamentos do WhatsApp',
    badge: 'CORREÇÕES',
    items: [
      { icon: 'fa-shield-halved', text: 'Corrigido um caso em que um lançamento feito pelo WhatsApp/Telegram com o app aberto ao mesmo tempo podia ser sobrescrito e sumir. Agora esses lançamentos são sempre preservados.' },
    ],
  },
  {
    id: 'wn-2026-07-19f',
    date: '19/07/2026',
    version: 'Simulador de Quitação e Previsões turbinadas',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-route', text: 'Simulador de Quitação (tela Dívidas): escolha Bola de Neve ⛄ ou Avalanche 🏔️, diga quanto consegue pagar a mais por mês e veja quando fica livre — com a economia de juros e o plano de ataque dívida por dívida.' },
      { icon: 'fa-binoculars', text: 'Previsões com Saldo Projetado: "se tudo que está pendente se confirmar, onde eu termino?" — com aviso vermelho se o saldo for ficar negativo.' },
      { icon: 'fa-layer-group', text: 'Previsões agrupadas por urgência: Atrasadas, Vencem hoje, Próximos 7 dias, Até o fim do mês e Mais pra frente — cada grupo com seu subtotal.' },
    ],
  },
  {
    id: 'wn-2026-07-19e',
    date: '19/07/2026',
    version: 'O app agora trabalha por você',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-whatsapp', text: 'Resumo semanal no WhatsApp: todo domingo às 19h você recebe sua semana em números — quanto gastou (comparado à anterior), onde mais foi e o que vence nos próximos 7 dias.' },
      { icon: 'fa-wand-magic-sparkles', text: 'Categoria automática: digite a descrição e o app preenche a categoria sozinho — primeiro pelo seu histórico, e se for algo novo, a IA sugere.' },
      { icon: 'fa-gauge-high', text: 'Alerta de orçamento na hora: ao lançar uma despesa (no app ou pelo WhatsApp), se a categoria passar do limite planejado você é avisado no ato — não só no fim do mês.' },
    ],
  },
  {
    id: 'wn-2026-07-19d',
    date: '19/07/2026',
    version: 'Alocação Alvo, Alertas de Preço e Renda Passiva',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-bullseye', text: 'Alocação Alvo: defina quanto % quer em cada tipo de ativo. O app compara com sua posição real e responde "se eu aportar R$ X, onde coloco?" — rebalanceamento sem planilha.' },
      { icon: 'fa-bell', text: 'Alertas de preço: escolha 3%, 5% ou 10% em cada ativo e receba push ou WhatsApp quando a cotação variar isso no dia (no máximo 1 aviso por ativo por dia).' },
      { icon: 'fa-umbrella-beach', text: 'Meta de Renda Passiva: "quero R$ 500/mês de dividendos" — barra de progresso comparando com a média líquida dos seus últimos 6 meses de proventos.' },
    ],
  },
  {
    id: 'wn-2026-07-19c',
    date: '19/07/2026',
    version: 'Investimentos em dólar de verdade',
    badge: 'MELHORIAS',
    items: [
      { icon: 'fa-dollar-sign', text: 'Ativo em US$ agora é 100% em dólar: investido, valor atual, preço médio e dividendos aparecem em US$ (com o equivalente em R$ do lado) — igualzinho à sua corretora.' },
      { icon: 'fa-cart-plus', text: 'Ao cadastrar um investimento novo, escolha a "conta que pagou": a 1ª compra entra no extrato do ativo e desconta do saldo da conta.' },
      { icon: 'fa-percent', text: 'Dividendo com imposto retido na fonte: informe o imposto no mesmo lançamento — o app registra a entrada e a saída, e o total de dividendos fica líquido.' },
      { icon: 'fa-divide', text: 'Cotas fracionadas com até 5 casas decimais (ex: 3,79206) e cotação automática mesmo com nome por extenso terminando no ticker (ex: "... - SGOV").' },
    ],
  },
  {
    id: 'wn-2026-07-19b',
    date: '19/07/2026',
    version: 'Gráficos de Investimentos',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-chart-line', text: 'Evolução do Patrimônio: o app agora fotografa sua carteira todo mês e mostra um gráfico da evolução — carteira vs. total investido, o vão entre as linhas é o seu lucro.' },
      { icon: 'fa-coins', text: 'Proventos por mês: gráfico de barras dos dividendos, JCP e rendimentos dos últimos 12 meses, com filtro por ativo e total do período.' },
      { icon: 'fa-camera', text: 'O histórico começa a ser gravado hoje — quanto mais tempo de uso, mais completo o gráfico fica.' },
    ],
  },
  {
    id: 'wn-2026-07-19',
    date: '19/07/2026',
    version: 'Contas em dólar (US$)',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-dollar-sign', text: 'Contas em dólar: ao criar ou editar uma conta (ex: Nomad, Wise), escolha a moeda US$. O saldo aparece em dólar, com o equivalente em reais do lado.' },
      { icon: 'fa-arrow-right-arrow-left', text: 'Transferência com câmbio: mandou R$ 100 e chegaram US$ 18? A transferência agora pede os dois valores (com sugestão pelo câmbio do dia) e mostra o câmbio efetivo.' },
      { icon: 'fa-chart-line', text: 'Investir a partir da conta em dólar: compras, vendas e dividendos em US$ debitam/creditam o saldo em dólar certinho — e o app converte pra R$ nos totais.' },
      { icon: 'fa-calculator', text: 'Saldo total, saúde financeira e projeções convertem tudo pro real automaticamente pelo câmbio do dia.' },
    ],
  },
  {
    id: 'wn-2026-07-18',
    date: '18/07/2026',
    version: 'Lançamento mais rápido e Assinaturas corrigidas',
    badge: 'MELHORIAS',
    items: [
      { icon: 'fa-bolt', text: 'Tela de novo lançamento mais enxuta: Tags, Observações e Comprovante agora ficam recolhidos em botõezinhos — toque neles só quando precisar.' },
      { icon: 'fa-repeat', text: 'Corrigido: marcar "É uma assinatura" ao EDITAR um lançamento que já existia agora funciona — a marcação vale pra série inteira e aparece na aba Assinaturas.' },
      { icon: 'fa-pen', text: 'Ao editar um lançamento, o campo Recorrência agora mostra se ele faz parte de uma série, sem textos confusos.' },
    ],
  },
  {
    id: 'wn-2026-07-12',
    date: '12/07/2026',
    version: 'Divisão de Salário e Investimentos no Exterior',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-scale-balanced', text: 'Nova tela "Divisão de Salário" — divida sua renda em fatias personalizadas (não só 50/30/20) e acompanhe a projeção de liberdade financeira pela regra dos 4%.' },
      { icon: 'fa-piggy-bank', text: '"Bola de neve": o assistente no WhatsApp/Telegram avisa quando os dividendos acumulados já dão pra comprar mais uma cota.' },
      { icon: 'fa-coins', text: 'Registro de Dividendo/JCP direto na tela de Investimentos.' },
      { icon: 'fa-dollar-sign', text: 'Suporte a investimentos em dólar (ex: Nomad) com cotação e conversão automáticas.' },
    ],
  },
  {
    id: 'wn-2026-07-10',
    date: '10/07/2026',
    version: 'Áudio no WhatsApp e Telegram',
    badge: 'NOVOS RECURSOS',
    items: [
      { icon: 'fa-microphone', text: 'Agora dá pra mandar um áudio contando um gasto ou pedindo um relatório — no WhatsApp e no Telegram.' },
      { icon: 'fa-clock', text: 'Comando "contas a vencer" ganhou prazo customizável: peça "em 15 dias", "próximos 30 dias", etc.' },
    ],
  },
  {
    id: 'wn-2026-07-04',
    date: '04/07/2026',
    version: 'Novo visual e WhatsApp mais esperto',
    badge: 'MELHORIAS',
    items: [
      { icon: 'fa-tags', text: 'Categorias com novo visual em cards — mais fácil de organizar e buscar.' },
      { icon: 'fa-whatsapp', text: 'WhatsApp IA agora pergunta qual conta ou cartão você usou antes de lançar.' },
    ],
  },
];

// Chave de opt-out é PERMANENTE (localStorage) — só quem clica explicitamente em
// "Não quero mais ver" para de ver o banner pra sempre. A chave de "visto nesta
// sessão" é por aba (sessionStorage) — o banner volta a aparecer toda vez que a
// pessoa abre o app de novo (novo login/nova sessão), pra ninguém esquecer que o
// sistema está sempre evoluindo. Fechar com o X ou "Entendi!" só fecha por agora.
export function WhatsNewBanner({ onOpenHistory }) {
  const latest = WHATS_NEW_HISTORY[0];
  const optOutKey = 'maw_whatsnew_optout';
  const seenThisSessionKey = `maw_whatsnew_seen_${latest.id}`;
  const [visible, setVisible] = useState(() => {
    try {
      if (localStorage.getItem(optOutKey)) return false;
      if (sessionStorage.getItem(seenThisSessionKey)) return false;
      return true;
    } catch { return true; }
  });
  if (!visible) return null;
  const closeForNow = () => {
    try { sessionStorage.setItem(seenThisSessionKey, '1'); } catch {}
    setVisible(false);
  };
  const optOut = () => {
    try {
      localStorage.setItem(optOutKey, '1');
      sessionStorage.setItem(seenThisSessionKey, '1');
    } catch {}
    setVisible(false);
  };
  return (
    <div className="whats-new-banner" style={{
      position: 'fixed', top: 78, right: 20, zIndex: 9995,
      background: '#0d1b2a', border: '1px solid var(--gold)', borderRadius: 16,
      padding: '16px 18px', width: 320, maxWidth: 'calc(100% - 32px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
      animation: 'slideInRight 0.3s ease',
    }}>
      <button
        onClick={closeForNow}
        aria-label="Fechar"
        style={{ position: 'absolute', top: 10, right: 10, background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: 14, padding: 4 }}
      >
        <i className="fas fa-xmark"></i>
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, paddingRight: 20 }}>
        <i className="fas fa-sparkles" style={{ color: 'var(--gold)', fontSize: 16 }}></i>
        <strong style={{ color: '#fff', fontSize: 14 }}>Novidades no MAW Finanças!</strong>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {latest.items.map((it, i) => (
          <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12.5, color: 'rgba(255,255,255,0.85)', lineHeight: 1.5 }}>
            <i className={`fas ${it.icon}`} style={{ color: 'var(--gold)', marginTop: 2, width: 14, flexShrink: 0 }}></i>
            <span>{it.text}</span>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
        <button
          onClick={() => { closeForNow(); onOpenHistory && onOpenHistory(); }}
          style={{ flex: 1, background: 'none', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 8, color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: 12, padding: '9px 0', cursor: 'pointer' }}
        >
          Ver tudo
        </button>
        <button
          onClick={closeForNow}
          style={{ flex: 1, background: 'var(--gold)', border: 'none', borderRadius: 8, color: '#0d1b2a', fontWeight: 700, fontSize: 12, padding: '9px 0', cursor: 'pointer' }}
        >
          Entendi!
        </button>
      </div>
      <button
        onClick={optOut}
        style={{ display: 'block', width: '100%', textAlign: 'center', marginTop: 10, background: 'none', border: 'none', color: 'rgba(255,255,255,0.35)', fontSize: 10.5, cursor: 'pointer', padding: 2, textDecoration: 'underline' }}
      >
        Não quero mais ver esses avisos
      </button>
    </div>
  );
}

export function NovidadesModal({ onClose }) {
  return (
    <div className="modal-backdrop">
      <div className="modal" style={{ maxWidth: 560, padding: 0, overflow: 'hidden' }}>
        <div style={{
          padding: '24px 28px 20px', background: 'linear-gradient(135deg,#0d1b2a,#16283d)',
          position: 'relative', textAlign: 'center',
        }}>
          <button
            onClick={onClose}
            aria-label="Fechar"
            style={{ position: 'absolute', top: 14, right: 14, background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 8, color: 'rgba(255,255,255,0.7)', cursor: 'pointer', fontSize: 15, width: 30, height: 30 }}
          >
            <i className="fas fa-xmark"></i>
          </button>
          <div style={{ fontSize: 11, letterSpacing: 2, color: 'var(--gold)', fontWeight: 700, marginBottom: 6 }}>
            <i className="fas fa-sparkles" style={{ marginRight: 6 }}></i>NOVIDADES
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#fff' }}>Acompanhe as últimas atualizações do MAW Finanças</div>
        </div>

        <div style={{ padding: '24px 28px 28px', maxHeight: '60vh', overflowY: 'auto' }}>
          <div style={{ position: 'relative', paddingLeft: 26 }}>
            <div style={{ position: 'absolute', left: 5, top: 6, bottom: 6, width: 2, background: 'var(--border)' }}></div>
            {WHATS_NEW_HISTORY.map((entry, idx) => {
              const badge = BADGE_STYLE[entry.badge] || BADGE_STYLE['MELHORIAS'];
              return (
                <div key={entry.id} style={{ position: 'relative', marginBottom: idx === WHATS_NEW_HISTORY.length - 1 ? 0 : 24 }}>
                  <div style={{
                    position: 'absolute', left: -26, top: 4, width: 12, height: 12, borderRadius: '50%',
                    background: idx === 0 ? 'var(--gold)' : 'var(--surface2)',
                    border: idx === 0 ? '2px solid var(--gold)' : '2px solid var(--border)',
                  }}></div>
                  <div style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 600, marginBottom: 8 }}>{entry.date}</div>
                  <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 12, padding: '16px 18px' }}>
                    <span style={{
                      display: 'inline-block', fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
                      background: badge.bg, color: badge.color, borderRadius: 6, padding: '3px 8px', marginBottom: 8,
                    }}>{entry.badge}</span>
                    <div style={{ fontWeight: 700, fontSize: 14.5, color: 'var(--text)', marginBottom: 10 }}>{entry.version}</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {entry.items.map((it, i) => (
                        <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13, color: 'var(--text)', lineHeight: 1.5 }}>
                          <i className={`fas ${it.icon}`} style={{ color: 'var(--gold)', marginTop: 3, width: 14, flexShrink: 0 }}></i>
                          <span>{it.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
